import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryFeatureRedeemFailConfirm = props => (
	<Confirm
		alertTitle={localize('redeem_code_fail_title')}
		btTwo={localize('redeem_user_used_button')}
		alertMessage={localize('redeem_user_used_once')}
		actionTwo={props.actions.closeFeatureRedeemFailConfirm}
		closeAction={props.actions.closeFeatureRedeemFailConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeFeatureRedeemFailConfirm: myLibraryActions.closeFeatureRedeemFailConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryFeatureRedeemFailConfirm)

export { MyLibraryFeatureRedeemFailConfirm }
